import {SharedLoyaltyActions, SharedLoyaltyActionsTypes} from "../actions/loyalty.actions";


export interface Loyalty {
  enabled_for_account: boolean;
  enabled_for_market: boolean;
}

export interface State {
  loyaltyConfig: Loyalty;
  isLoading: boolean;
}

export const initialState: State = {
  loyaltyConfig: <Loyalty>{},
  isLoading: false
};

export function reducer(state = initialState, action: SharedLoyaltyActions): State {

  switch (action.type) {

    case SharedLoyaltyActionsTypes.InitSharedLoyaltyConfig:
      return { ...state, isLoading: true };


    case SharedLoyaltyActionsTypes.SetSharedLoyaltyConfig:
      return { ...state, loyaltyConfig: { ...action.payload.loyaltyConfig }, isLoading: false };

    default:
      return state;

  }
}
